'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _zh_CN = require('rc-pagination/lib/locale/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _zh_CN2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/pagination/locale/zh_CN.tsx
 ** module id = 343
 ** module chunks = 0
 **/